export class DebounceHelper {
  // Debounce reduces the overhead by preventing a function from being called
  // several times in succession. It will wait until the function isn't called
  // for a defined number of milliseconds, and they fire it.
  static debounce(func, wait, immediate) {
    var timeoutId

    function debounced() {
      var context = this,
        args = arguments
      var later = function () {
        timeoutId = null
        if (!immediate) func.apply(context, args)
      }
      var callNow = immediate && !timeoutId
      clearTimeout(timeoutId)
      timeoutId = setTimeout(later, wait)
      if (callNow) func.apply(context, args)
    }

    debounced.cancel = function () {
      clearTimeout(timeoutId)
    }

    return debounced
  }
}
